import { render, staticRenderFns } from "./ParagraphForm.vue?vue&type=template&id=2ab457eb&scoped=true&"
import script from "./ParagraphForm.vue?vue&type=script&lang=js&"
export * from "./ParagraphForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab457eb",
  null
  
)

export default component.exports